import { Component, Input } from '@angular/core';
import { ExportJsonService } from '../_services/export-json.service';

@Component({
	selector: 'app-download-table-button',
	templateUrl: './download-table-button.component.html',
	styleUrls: ['./download-table-button.component.css'],
})
export class DownloadTableButtonComponent {
	@Input() count: number = 0;
	@Input() tableId: string;
	@Input() filename: string;
	@Input() excludedColumns: string[] = [];
	@Input() csvFormat: boolean = true;
	@Input() xlsxFormat: boolean = true;

	public readonly CSV: boolean = true;
	public readonly XLSX: boolean = false;

	constructor(public exportJsonService: ExportJsonService) {}

	downloadCsv(): void {
		this.exportJsonService.exportTable(this.tableId, this.filename, this.CSV, this.excludedColumns);
	}

	downloadXlsx(): void {
		this.exportJsonService.exportTable(this.tableId, this.filename, this.XLSX, this.excludedColumns);
	}
}

